import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const LockableWrapper = (props) => (
  <div className="c-protected-input">
    {props.children}
    <div
      display-if={props.disabled}
      className={classNames('c-protected-input-trigger', props.greyLock && 'c-protected-input-trigger--grey-lock')}
    >
      <span display-if={props.hint} className="c-protected-input-popup">
        {props.hint}
      </span>
    </div>
  </div>
);

LockableWrapper.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  hint: PropTypes.string,
  greyLock: PropTypes.bool,
};

LockableWrapper.defaultProps = {
  children: null,
  disabled: false,
  hint: '',
  greyLock: false,
};

export default LockableWrapper;
